import { cloneDeep } from 'lodash';

import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TaskEditParentService } from '../utils/task-edit-parent.service';
import { AttachmentsTemplateComponent } from "../../attachments-template/attachments-template.component";
import { BoxCommentsComponent } from '@shared/components/box-comments/box-comments.component';
import { StatesProcessComponent } from "../../states-process/states-process.component";
import { TaskHistoricComponent } from '@shared/components/task-historic/task-historic.component';
import { TaskFormComponent } from "../../task-form/task-form.component";


@Component({
    selector: 'task-edit-custom',
    templateUrl: './task-edit-custom.component.html',
    imports: [
        BoxCommentsComponent,
        StatesProcessComponent,
        AttachmentsTemplateComponent,
        TaskHistoricComponent,
        TaskFormComponent
    ]
})
export class TaskEditCustomComponent implements OnChanges {

  currentComponent: string = this.route.snapshot.data['componentName'];
  isLanding:any = true;
  taskId:any = this.route.snapshot.params['taskId'];
  taskEdit: any = {
    fullScreenBox: '',
    typeStatesProcess: 'normalTask',
    taskSelect: {},
    temporalDocuments: [],
    attachmentListDocument: [],
    historicList: []
  }
  constructor(private route: ActivatedRoute,
    private router: Router,
    private taskEditParent: TaskEditParentService) {
    }

  @Input() concept:any = {};
  @Input() taskSelect:any = {};
  @Input() shared:any = null;

  @Output() changeView = new EventEmitter();
  @Output() modifyTaskList = new EventEmitter();

  ngOnChanges(): void {
    this.taskEdit.concept = this.concept;
    if (this.taskSelect !== null && this.taskSelect !== undefined) {
      this.taskEdit.taskSelect = this.taskSelect;
      this.taskEdit.taskCopy = cloneDeep(this.taskSelect);
      this.taskEditParent.configureTaskSelect(this);
    }else{
      this.taskEditParent.configureNewTask(this);
    }

  }

  hasFullScreen(e:any){
    this.taskEdit.fullScreenBox = this.taskEdit.fullScreenBox === e.box? '' : e.box;
  }

  changeState(e:any){
    this.taskEditParent.changeState(e.task, this)
  }
  changeResponsible(e:any){
    this.taskEditParent.changeResponsible(e.responsible, this)
  }
  cancelCreateTask(){
    this.taskEditParent.cancelCreateTask(this)
  }
  createAlert(alert:any){
    this.taskEditParent.createAlert(alert, this)
  }

  launchAction(action:any){
    this.taskEditParent.launchAction(action, this)
  }
}
